import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { Subscription, Observable, of, forkJoin } from 'rxjs';


interface RolePermission {
  role_key: string;
  element_key: string;
  [key: string]: any; // Allow any additional properties
}



@Directive({
  selector: '[hasPermission]'
})
export class HasPermissionDirective {


 private subscription: Subscription | undefined;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,

  ) { }

  @Input() set hasPermission(permissionString: string) {

    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    if (!permissionString) {
      // If no permissionString is provided, return true (show the element).
      this.renderer.removeStyle(this.elementRef.nativeElement, 'display');
      return;
    }
    const [elementKey, permissions] = permissionString.split('|').map(part => part.trim());
    const permissionArray = permissions.split(',').map(permission => permission.trim());

    this.subscription = this.checkPermissions(elementKey, permissionArray).subscribe(hasPermission => {

      if (hasPermission) {
        this.renderer.removeStyle(this.elementRef.nativeElement, 'display');
      } else {
        this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'none');
      }
    });
  }




  private checkPermissions(elementKey: string, requiredPermissions: string[]): Observable<boolean> {
    const userDataString = JSON.parse(localStorage.getItem('userData') || '{}') || {};
   
    if (!userDataString) {
      // Redirect to login or another appropriate page if userData is not available
      // this.router.navigate(['/auth/login']);
      return of(false);
    }
    // const userData = JSON.parse(userDataString);
    const userData =userDataString;
    return new Observable<boolean>((observer) => {
      const rolePermissionsObservables: Observable<boolean>[] = [];
  
      for (const role of userData.Roles) {
        const rolePermissionObservable = new Observable<boolean>((roleObserver) => {
          // Find permissions for the current role
          const rolePermissions: RolePermission[] = userData.RoleMenuPermissions.filter((permission: RolePermission) => permission.role_key === role);
  
          if (rolePermissions.length > 0) {
            // Check if the role has the required permissions for the element
            const hasPermission = rolePermissions.some((permission: RolePermission) => {
              return permission.element_key.toUpperCase() === elementKey.toUpperCase() &&
                requiredPermissions.every(requiredPermission => permission.hasOwnProperty(requiredPermission) && permission[requiredPermission] === true);
            });
            roleObserver.next(hasPermission);
          } else {
            // Role has no permissions defined
            roleObserver.next(false);
          }
          roleObserver.complete();
        });
        rolePermissionsObservables.push(rolePermissionObservable);
      }
  
      // Combine observables for all roles
      forkJoin(rolePermissionsObservables).subscribe(results => {
        // User has permission if any role has permission
        const hasPermission = results.some(result => result === true);
        observer.next(hasPermission);
        observer.complete();
      });
    });
  }



  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }


}
